<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>AGENTES DEL SISTEMA</h6>
        </div>
        <div class="col">
          <button class="btn bg-gradient-success float-end" @click="$router.push('/create-agent')"> Crear nuevo agente</button>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <!-- Asignacion masiva de IP a TODOS los agentes -->
      <div class="row align-items-end mb-4">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <label>Asignar una misma IP a TODOS los agentes</label>
          <input type="text" class="form-control" v-model="bulkIp" placeholder="Ej: 190.120.10.5 (vacio = quitar IP)">
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12">
          <button class="btn bg-gradient-info w-100 mb-0" @click="assignIpBulk">Asignar IP a todos</button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered table-striped table-sm">
          <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Name</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Email</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Telefono</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Identificacion</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">IP Autorizada</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, key) in arrayAgents" :key="key">
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.name}}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.email}}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.phone}}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.identification}}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.status?'ACTIVO':'INACTIVO'}}</p>
            </td>
            <td>
              <input v-if="item.type === 'agent'" type="text" class="form-control form-control-sm" v-model="item.allowed_ip" placeholder="Sin IP">
              <p v-else class="text-xs text-secondary mb-0">No aplica</p>
            </td>
            <td>
              <button v-if="item.type === 'agent'" class="btn btn-outline-info btn-sm mb-0 me-2" @click="assignIp(item)">Guardar IP</button>
              <button v-if="item.type === 'agent'" class="btn btn-outline-danger btn-sm mb-0" @click="deleteAgent(item)">Eliminar</button>
              <span v-if="item.type !== 'agent'" class="text-xs text-secondary">—</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";

export default {
  name: "agents-index",
  data: () => ({
    arrayAgents: [],
    bulkIp: '',
  }),
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        const {data} = await get('users/list-staff');
        this.arrayAgents = data;
      } catch (error) {
        console.error(error);
      }
    },
    async assignIp(item) {
      const {data} = await post('users/assign-ip', {_id: item._id, allowed_ip: item.allowed_ip || null});
      if(data === 200){
        this.$swal({
          html: 'IP asignada correctamente',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }else{
        this.$swal({
          html: data.message || 'No se pudo asignar la IP',
          icon: 'error',
          timer: 2500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    async deleteAgent(item) {
      const confirm = await this.$swal({
        title: '¿Eliminar este agente?',
        text: `Se eliminará a ${item.name || item.email}. Sus leads quedarán sin asignar.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.isConfirmed) return;
      const {data} = await post('users/delete-agent', {_id: item._id});
      if (data === 200) {
        this.$swal({
          html: 'Agente eliminado correctamente',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
        await this.getData();
      } else {
        this.$swal({
          html: (data && data.message) || 'No se pudo eliminar el agente',
          icon: 'error',
          timer: 2500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    async assignIpBulk() {
      const confirm = await this.$swal({
        title: '¿Asignar esta IP a TODOS los agentes?',
        text: this.bulkIp ? this.bulkIp : 'Se quitará la IP a todos los agentes',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, asignar',
        cancelButtonText: 'Cancelar',
      });
      if(!confirm.isConfirmed) return;
      const {data} = await post('users/assign-ip-bulk', {allowed_ip: this.bulkIp || null});
      if(data && data.statusCode === 200){
        this.$swal({
          html: `IP asignada a ${data.updated} agentes`,
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
        await this.getData();
      }
    }
  }
};
</script>

<style scoped>
</style>
